import styled, { css } from 'styled-components';
import { color, font, query, space } from '@design/templateFns';
import { InputGroup } from '@components/FormFields/';

export const InteriorHeroWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  padding-top: ${space('x8')};
  padding-bottom: ${space('x6')};

  @media screen and (${query.atLeast('desktop')}) {
    flex-direction: row;
  }

  section {
    padding: 0;
  }
`;

export const SearchbarWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  padding-top: ${space('lg')};
  padding-bottom: ${space('lg')};
  border-bottom: 1px solid ${color('gray2')};

  @media screen and (${query.atLeast('desktop')}) {
    flex-direction: row;
  }

  section {
    padding: 0;
  }
`;

export const AdvisorFilterWrapper = styled.div``;

export const SearchInputWrapper = styled(InputGroup)`
  width: 100%;
  position: relative;
  @media screen and (${query.atLeast('desktop')}) {
    flex: 0 1 325px;
    max-width: 325px;
  }
`;

export const SearchInput = styled.input<{ $active: boolean }>`
  z-index: 10;
  background-color: ${({ $active }) =>
    $active ? `${color('gray1')()} !important` : 'transparent'};
  border-color: ${({ $active }) => ($active ? `${color('gray1')()} !important` : color('gray2'))};
  &:focus {
    border-color: #d4d4d4;
    box-shadow: 0 0 0 0px #d4d4d4 !important;
  }
`;

export const SearchButton = styled.button``;

export const AdvisorListWrapper = styled.div`
  padding-bottom: ${space('x10')};

  @media screen and (${query.atLeast('max')}) {
    padding-bottom: ${space('x14')};
  }
`;

export const Headline = styled.h1`
  ${font('headline-sm')};
  text-align: left;
  padding-top: ${space('x6')};
  padding-bottom: ${space('sm')};
  @media (${query.below('tablet')}) {
    ${font('headline-xxs')};
    padding-top: ${space('x6')};
  }
`;

export const AdvisorHeaderContainer = styled.div`
  display: flex;
  padding-bottom: ${space('x6')};
  flex-direction: column-reverse;
  gap: ${space('xs')};
`;

export const AdvisorHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: ${space('xs')};
  justify-content: space-between;
  div:first-child {
    @media screen and (${query.below('desktop')}) {
      flex: 0 0 100%;
      width: 100%;
    }
  }
  @media screen and (${query.below('tablet')}) {
    padding-top: ${space('xs')};
    gap: 3px;
    justify-content: space-between;
  }
`;

export const AdvisorContainer = styled.div`
  margin-top: ${space('x6')};
  @media (${query.below('tablet')}) {
    margin-top: 0;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;
